import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { useEffect, useState } from "react";
import { Review } from '../@types/types';
import { format, add } from 'date-fns';

import workout from "../assets/Img/IconPremium/workout-schedule.png";
import weightlifting from "../assets/Img/IconPremium/weightlifting.png";
import money from "../assets/Img/IconPremium/money-management.png";
import setting from "../assets/Img/IconPremium/ai-setting.png";
import list from "../assets/Img/IconPremium/to-do-list.png";
import ebook from "../assets/Img/IconPremium/ebook.png";
import calculate from "../assets/Img/IconPremium/calculate.png";
import calculator from "../assets/Img/IconPremium/calculator.png";
import video from "../assets/Img/IconPremium/video.png";

import ImageApp1PT from "../assets/Img/ImageApp/PT/1.png";
import ImageApp2PT from "../assets/Img/ImageApp/PT/2.png";
import ImageApp3PT from "../assets/Img/ImageApp/PT/3.png";
import ImageApp4PT from "../assets/Img/ImageApp/PT/4.png";
import ImageApp5PT from "../assets/Img/ImageApp/PT/5.png";
import ImageApp6PT from "../assets/Img/ImageApp/PT/6.png";
import ImageApp7PT from "../assets/Img/ImageApp/PT/7.png";
import ImageApp8PT from "../assets/Img/ImageApp/PT/8.png";
import ImageApp9PT from "../assets/Img/ImageApp/PT/9.png";
import ImageApp10PT from "../assets/Img/ImageApp/PT/10.png";
import ImageApp11PT from "../assets/Img/ImageApp/PT/11.png";
import ImageApp12PT from "../assets/Img/ImageApp/PT/12.png";

import ImageApp1EN from "../assets/Img/ImageApp/EN/1.png";
import ImageApp2EN from "../assets/Img/ImageApp/EN/2.png";
import ImageApp3EN from "../assets/Img/ImageApp/EN/3.png";
import ImageApp4EN from "../assets/Img/ImageApp/EN/4.png";
import ImageApp5EN from "../assets/Img/ImageApp/EN/5.png";
import ImageApp6EN from "../assets/Img/ImageApp/EN/6.png";
import ImageApp7EN from "../assets/Img/ImageApp/EN/7.png";
import ImageApp8EN from "../assets/Img/ImageApp/EN/8.png";
import ImageApp9EN from "../assets/Img/ImageApp/EN/9.png";
import ImageApp10EN from "../assets/Img/ImageApp/EN/10.png";
import ImageApp11EN from "../assets/Img/ImageApp/EN/11.png";
import ImageApp12EN from "../assets/Img/ImageApp/EN/12.png";

import testimonial1 from "../assets/Img/testimonial/testimonial1.png";
import testimonial2 from "../assets/Img/testimonial/testimonial2.png";
import testimonial3 from "../assets/Img/testimonial/testimonial3.jpg";

import right from "../assets/Img/right.png";
import price from "../assets/Img/price.png";

import usePaymentController from './usePaymentController';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

export function usePromotionController() {
    const db = getFirestore();
    const [reviews, setReviews] = useState<Review[]>([]);
    const { t } = useTranslation();
    const [loadingCheckout, setLoadingCheckout] = useState(false);

    function handleCheckout01() {
        window.open("https://go.perfectpay.com.br/PPU38CP7HBK", "_blank");
    }
    function handleCheckout02() {
        window.open("https://go.perfectpay.com.br/PPU38CP7HBK", "_blank");
    }
    function handleCheckout03() {
        window.open("https://pay.hotmart.com/Y95851681E?off=va95zujr", "_blank");
    }

    const {
        handleCheckout,
        loading,
        showSuccess,
        showFailure,
        showProcessing,
    } = usePaymentController();

    const calculateExpirationDate90 = () => {
        const dataAtual = new Date();
        const dataExpiracao = add(dataAtual, { days: 90 });
        const dataExpiracaoFormatada = format(dataExpiracao, 'dd/MM/yyyy');

        return dataExpiracaoFormatada;
    };
    const calculateExpirationDate30 = () => {
        const dataAtual = new Date();
        const dataExpiracao = add(dataAtual, { days: 30 });
        const dataExpiracaoFormatada = format(dataExpiracao, 'dd/MM/yyyy');

        return dataExpiracaoFormatada;
    };
    const calculateExpirationDate7 = () => {
        const dataAtual = new Date();
        const dataExpiracao = add(dataAtual, { days: 7 });
        const dataExpiracaoFormatada = format(dataExpiracao, 'dd/MM/yyyy');

        return dataExpiracaoFormatada;
    };

    const data = [
        {
            id: 1,
            title: t("usePromotionController_promotion_optimizedWorkouts"),
            description: t("usePromotionController_promotion_correctWorkoutDescription"),
            image: workout
        },
        {
            id: 2,
            title: t("usePromotionController_promotion_trainingPartner"),
            description: t("usePromotionController_promotion_trainingPartnerDescription"),
            image: weightlifting
        },
        {
            id: 3,
            title: t("usePromotionController_promotion_noAds"),
            description: t("usePromotionController_promotion_noAdsDescription"),
            image: money
        },
        {
            id: 4,
            title: t("usePromotionController_promotion_artificialIntelligence"),
            description: t("usePromotionController_promotion_aiDescription"),
            image: setting
        },
        {
            id: 5,
            title: t("usePromotionController_promotion_createYourWorkouts"),
            description: t("usePromotionController_promotion_createYourWorkoutsDescription"),
            image: list
        },
        {
            id: 6,
            title: t("usePromotionController_promotion_freeEbooks"),
            description: t("usePromotionController_promotion_freeEbooksDescription"),
            image: ebook
        },
        {
            id: 7,
            title: t("usePromotionController_promotion_imcCalculator"),
            description: t("usePromotionController_promotion_imcCalculatorDescription"),
            image: calculate
        },
        {
            id: 8,
            title: t("usePromotionController_promotion_bodyFatCalculator"),
            description: t("usePromotionController_promotion_bodyFatCalculatorDescription"),
            image: calculator
        },
        {
            id: 9,
            title: t("usePromotionController_promotion_shortExerciseVideos"),
            description: t("usePromotionController_promotion_shortExerciseVideosDescription"),
            image: video
        }
    ];

    const benefits = [
        {
            id: 1,
            title: t('usePromotionController_benefit_1_title'),
            price: t('usePromotionController_benefit_1_price'),
            image: right
        },
        {
            id: 2,
            title: t('usePromotionController_benefit_2_title'),
            price: t('usePromotionController_benefit_2_price'),
            image: right
        },
        {
            id: 3,
            title: t('usePromotionController_benefit_3_title'),
            price: t('usePromotionController_benefit_3_price'),
            image: right
        },
        {
            id: 4,
            title: t('usePromotionController_benefit_4_title'),
            price: t('usePromotionController_benefit_4_price'),
            image: right
        },
        {
            id: 5,
            title: t('usePromotionController_benefit_5_title'),
            price: t('usePromotionController_benefit_5_price'),
            image: right
        },
        {
            id: 6,
            title: t('usePromotionController_benefit_6_title'),
            price: t('usePromotionController_benefit_6_price'),
            image: right
        },
        {
            id: 7,
            title: t('usePromotionController_benefit_7_title'),
            price: t('usePromotionController_benefit_7_price'),
            image: right
        },
        {
            id: 8,
            title: t('usePromotionController_benefit_8_title'),
            price: t('usePromotionController_benefit_8_price'),
            image: price,
        },
        {
            id: 9,
            title: t('usePromotionController_benefit_9_title'),
            price: t('usePromotionController_benefit_9_price'),
            image: ''
        },
        {
            id: 10,
            title: t('usePromotionController_benefit_10_title'),
            price: t('usePromotionController_benefit_10_price'),
            image: ''
        }
    ];

    const imagesAppPT = [
        ImageApp1PT,
        ImageApp2PT,
        ImageApp3PT,
        ImageApp4PT,
        ImageApp5PT,
        ImageApp6PT,
        ImageApp7PT,
        ImageApp8PT,
        ImageApp9PT,
        ImageApp10PT,
        ImageApp11PT,
        ImageApp12PT,
    ];

    const imagesAppEN = [
        ImageApp1EN,
        ImageApp2EN,
        ImageApp3EN,
        ImageApp4EN,
        ImageApp5EN,
        ImageApp6EN,
        ImageApp7EN,
        ImageApp8EN,
        ImageApp9EN,
        ImageApp10EN,
        ImageApp11EN,
        ImageApp12EN,
    ];

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };

    const planing = [
        // {
        //     bestOffer: t("usePlansController_plans_bestOffer"),
        //     flat: t("usePlansController_plans_oneWeekPlan"),
        //     price: "1,00",
        //     value: "1,00",
        //     ExpirationDate: calculateExpirationDate7,
        //     link: handleCheckout01
        // },
        {
            bestOffer: t("usePlansController_plans_mostPopular"),
            flat: t("usePlansController_plans_oneMonthPlan"),
            price: "1,00",
            value: "1,00",
            ExpirationDate: calculateExpirationDate30,
            link: handleCheckout02
        },
        // {
        //     bestOffer: t("usePlansController_plans_recommended"),
        //     flat: t("usePlansController_plans_threeMonthsPlan"),
        //     price: "30,00",
        //     value: "3",
        //     ExpirationDate: calculateExpirationDate90,
        //     link: handleCheckout03
        // },
    ]

    const testimonials = [
        {
            name: t("useTestimonialsController_testimonials_joaoSilva_name"),
            weightLoss: t("useTestimonialsController_testimonials_joaoSilva_weightLoss"),
            image: testimonial1,
            testimonial: t("useTestimonialsController_testimonials_joaoSilva_testimonial")
        },
        {
            name: t("useTestimonialsController_testimonials_carlosOliveira_name"),
            weightLoss: t("useTestimonialsController_testimonials_carlosOliveira_weightLoss"),
            image: testimonial2,
            testimonial: t("useTestimonialsController_testimonials_carlosOliveira_testimonial")
        },
        {
            name: t("useTestimonialsController_testimonials_natalia_name"),
            weightLoss: t("useTestimonialsController_testimonials_natalia_weightLoss"),
            image: testimonial3,
            testimonial: t("useTestimonialsController_testimonials_natalia_testimonial")
        },
    ];

    const [selectedPlan, setSelectedPlan] = useState<{
        bestOffer: string;
        flat: string;
        price: string;
        value: string;
        ExpirationDate: () => string;
    } | null>(null);

    const handleCardClick = (plan: {
        bestOffer: string;
        flat: string;
        price: string;
        value: string;
        ExpirationDate: () => string;
    }) => {
        setSelectedPlan(plan);
    };

    const handlePurchase = async () => {
        if (selectedPlan) {
            setLoadingCheckout(true); // Ativa o estado de carregamento
            try {
                const planWithExpiration = {
                    ...selectedPlan,
                    expirationDate: selectedPlan.ExpirationDate(),
                };
                await handleCheckout(planWithExpiration); // Espera o checkout finalizar
                setLoadingCheckout(false); // Desativa o estado de carregamento após o sucesso
            } catch (error) {
                setLoadingCheckout(false); // Desativa o estado de carregamento em caso de erro
                console.error('Erro no checkout:', error);
                toast.error(t('usePlansController_plans_error'));
            }
        } else {
            toast.error(t('usePlansController_plans_selectPlan'));
        }
    };

    async function fetchReviews() {
        try {
            const docRef = doc(db, 'assessments', 'latest_reviews');
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                const data = docSnap.data();
                // Converte o objeto reviews em um array
                const reviewsArray = Object.values(data.reviews || {});
                return reviewsArray;
            } else {
                console.log('Nenhum documento encontrado!');
                return [];
            }
        } catch (error: any) {
            console.error('Erro ao buscar avaliações:', error);
            return [];
        }
    }

    useEffect(() => {
        const getReviews = async () => {
            const fetchedReviews = await fetchReviews();
            setReviews(fetchedReviews as any);
        };

        getReviews();
    }, []);

    return {
        reviews,
        loading,
        loadingCheckout,
        data,
        imagesAppPT,
        imagesAppEN,
        responsive,
        planing,
        handlePurchase,
        handleCardClick,
        selectedPlan,
        setSelectedPlan,
        showSuccess,
        showFailure,
        showProcessing,
        testimonials,
        benefits
    };
}
